import { render, staticRenderFns } from "./NotificationElement.vue?vue&type=template&id=68f5adf6&"
import script from "./NotificationElement.vue?vue&type=script&lang=js&"
export * from "./NotificationElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports